import request from '@/utils/request'

// 行业动态列表(首页无权限)
export function industryNoAuthList(query) {
    return request({
        url: '/business/industry/noAuth/boardList',
        method: 'get',
        params: query
    })
}

// 行业动态列表
export function industryList(query) {
    return request({
        url: '/business/industry/ironstoneList',
        method: 'get',
        params: query
    })
}

// 行业动态详情
export function industryDetail(id) {
    return request({
        url: `/business/industry/ironstoneInfo/${id}`,
        method: 'get',
    })
}

// 研究报告列表
export function reportPage(query) {
    return request({
        url: `/business/report/ironstoneList`,
        method: 'get',
        params:query
    })
}

// 研究报告详情
export function reportDetail(id) {
    return request({
        url: `/business/report/ironstoneInfo/${id}`,
        method: 'get',
    })
}

// 技术与标准列表
export function standardPage(query) {
    return request({
        url: `/business/report/ironstoneTechnicalList`,
        method: 'get',
        params:query
    })
}

// 技术与标准详情
export function standardDetail(id) {
    return request({
        url: `/business/report/ironstoneTechnicalInfo/${id}`,
        method: 'get',
    })
}

// 价格列表(首页无权限)
export function priceNoAuthList(query) {
    return request({
        url: '/business/metatron/price/noAuth/ironOreList',
        method: 'get',
        params: query
    })
}

// 价格列表
export function pricePage(query) {
    return request({
        url: '/business/metatron/price/ironOreList',
        method: 'get',
        params: query
    })
}

// 价格详情
export function priceDetail(query) {
    return request({
        url: '/business/metatron/price/detailsIronOre',
        method: 'get',
        params: query
    })
}

// 库存列表(首页无权限)
export function stockNoAuthList(query) {
    return request({
        url: '/business/metatron/stock/noAuth/ironOreList',
        method: 'get',
        params: query
    })
}

// 库存列表
export function stockPage(query) {
    return request({
        url: '/business/metatron/stock/ironOreList',
        method: 'get',
        params: query
    })
}

// 库存详情
export function stockDetail(query) {
    return request({
        url: '/business/metatron/stock/detailsIronOreList',
        method: 'get',
        params: query
    })
}

// 发运和到港列表(首页无权限)
export function despatchNoAuthList(query) {
    return request({
        url: '/business/metatron/despatch/noAuth/ironOreList',
        method: 'get',
        params: query
    })
}

// 发运和到港列表
export function despatchList(query) {
    return request({
        url: '/business/metatron/despatch/noAuth/ironOreList',
        method: 'get',
        params: query
    })
}

// 发运和到港详情
export function despatchDetail(query) {
    return request({
        url: `/business/metatron/despatch/detailsIronOreList`,
        method: 'get',
        params: query
    })
}

// 进出口列表(首页无权限)
export function exitNoAuthList(query) {
    return request({
        url: '/business/metatron/exit/noAuth/ironOreList',
        method: 'get',
        params: query
    })
}

// 进出口量列表
export function exitPage(query) {
    return request({
        url: '/business/metatron/exit/ironOreList',
        method: 'get',
        params: query
    })
}

// 进出口量详情
export function exitDetail(query) {
    return request({
        url: '/business/metatron/exit/detailsIronOreList',
        method: 'get',
        params: query
    })
}
